import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SelectFilter from './SelectFilter';
import { optionsPropTypes } from '../forms/select/SelectPropTypes';
import {
  clearAllBaggageExcesses,
  getAllExcessBaggages,
} from '../../../actions';

const ExcessBaggageFilter = ({
  excesBaggages,
  loading,
  dispatchGetExcessBaggages,
  dispatchClearExcessBaggages,
  isMulti,
  isClearable,
  ...rest
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearExcessBaggages();
    },
    [],
  );

  const onInputChange = (inputValue) => {
    const value = inputValue.trim();

    if (!value.length) return;
    const ticket = value.split('-');

    if (ticket.length !== 2) return;

    const [series, correlative] = ticket;

    if (series.length < 2 || correlative.length <= 1) return;

    const query = [`documentSeries:${series}`, `documentCode:${correlative}`];

    dispatchGetExcessBaggages({ query });
  };

  return (
    <SelectFilter
      isLoading={loading}
      onInputChange={onInputChange}
      options={excesBaggages}
      isMulti={isMulti}
      isClearable={isClearable}
      {...rest}
    />
  );
};

ExcessBaggageFilter.propTypes = {
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  loading: PropTypes.bool,
  isClearable: PropTypes.bool,
  excesBaggages: optionsPropTypes,
  dispatchGetExcessBaggages: PropTypes.func.isRequired,
  dispatchClearExcessBaggages: PropTypes.func.isRequired,
};

ExcessBaggageFilter.defaultProps = {
  placeholder: 'serie-correlativo...',
  isMulti: false,
  loading: false,
  isClearable: false,
  excesBaggages: [],
};

const mapStateToProps = ({ BaggageUnit }) => ({
  excesBaggages: BaggageUnit.ExcessBaggage.getIn([
    'all',
    'content',
    'content',
  ]).map((option) => ({
    value: option.id,
    label: option.fullDocumentCode,
  })),
  loading: BaggageUnit.ExcessBaggage.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetExcessBaggages: getAllExcessBaggages,
  dispatchClearExcessBaggages: clearAllBaggageExcesses,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExcessBaggageFilter);
